import { Snackbar as MuiSnackbar, type SnackbarProps as MuiSnackbarProps, type AlertProps } from '@mui/material';
import { DEFAULT_TRANSITION_DURATION, DEFAULT_AUTO_HIDE_DURATION } from 'contexts/SnackbarContext';
import Alert from 'components/feedbacks/Alert';

export type SnackbarProps = MuiSnackbarProps & AlertProps;

const Snackbar = ({
  autoHideDuration = DEFAULT_AUTO_HIDE_DURATION,
  transitionDuration = DEFAULT_TRANSITION_DURATION,
  message,
  severity,
  open,
  onClose,
  ...props
} : SnackbarProps) : JSX.Element => {

  if (!message || !severity) {
    return null;
  }
  
  return (
    <MuiSnackbar
      autoHideDuration={autoHideDuration}
      transitionDuration={transitionDuration}
      open={open}
      onClose={onClose}
      {...props}
      >
      <Alert
        severity={severity}
        onClose={onClose}
        sx={{mt: 0}}
      >
        {message}
      </Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
